import React, { forwardRef } from "react";
import type { CenterFX, StylesCfg } from "../types";

export const CenterZone = forwardRef<
  HTMLDivElement,
  {
    centerFX: CenterFX;
    styles?: StylesCfg;
    centerWidthPx: number;
  }
>(({ centerFX, styles, centerWidthPx }, ref) => {
  const centerBase =
    styles?.centerBaseClasses ??
    "bg-gradient-to-b from-[#69992F]/5 via-[#B0FF4F]/25 to-[#69992F]/5";

  const centerFxClasses =
    centerFX === "success"
      ? "ring-4 !from-[#69992F]/10 !via-[#B0FF4F]/35 !to-[#69992F]/10 ring-green-400/60 shadow-[0_0_40px_rgba(34,197,94,0.55)] scale-[1.02]"
      : centerFX === "fail" || centerFX === "miss"
      ? "ring-4 !from-[#992224]/5 !via-[#FF393C]/25 !to-[#FF393C]/5 ring-red-400/60 shadow-[0_0_40px_rgba(239,68,68,0.55)] scale-[0.99]"
      : "";

  const centerTransition = "transition-all duration-200 ease-out";

  return (
    <div
      ref={ref}
      className={`${centerBase} ${centerFxClasses} ${centerTransition} z-[50]`}
      style={{
        position: "absolute",
        top: 0,
        bottom: 0,
        left: "50%",
        transform: "translateX(-50%)",
        width: centerWidthPx,
        borderRadius: 12,
      }}
    />
  );
});

CenterZone.displayName = "CenterZone";
